import { defineMessages } from 'react-intl'

export default defineMessages({
  chatHeadline: {
    id: 'app.chat.headline',
    defaultMessage: 'Chat',
  },
  emailValid: {
    id: 'app.chat.input.email.valid',
    defaultMessage: 'Please enter your email!',
  },
  emailRequired: {
    id: 'app.chat.input.email.required',
    defaultMessage: 'Please enter a valid email!',
  },
  emailSubmittionError: {
    id: 'app.chat.email.submittion',
    defaultMessage: 'Something went wrong',
  },
  chatSendAMessage: {
    id: 'app.chat.sendAMessage',
    defaultMessage: 'Send a message...',
  },
  chatBotMessageFirst: {
    id: 'app.chat.botMessage.first',
    defaultMessage: 'Thank you for using our chat services. We will be with you momentarily.',
  },
  chatBotMessageSecond: {
    id: 'app.chat.botMessage.second',
    defaultMessage: 'We can also assist you if you provide us a way to reach you.',
  },
  chatStatusTyping: {
    id: 'app.chat.status.typing',
    defaultMessage: 'Typing...',
  },
  chatNewMessages: {
    id: 'app.chat.newMessages',
    defaultMessage: '{unreadMessages, plural, one {(#) New Message} other {(#) New Messages}}',
  },
})
